import { render, staticRenderFns } from "./RefusedList.vue?vue&type=template&id=44c7bd7a&"
import script from "./RefusedList.vue?vue&type=script&lang=js&"
export * from "./RefusedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports